<template>
  <div class="site-form-element-wrapper">
    <div class="site-form-element checkbox">
      <input class="site-form-input checkbox" type="checkbox" :name="inputName" :id="uniqId" @change="onChange" :value="modelValue">
      <label class="site-form-checkbox-icon" :for="uniqId"></label>
      <div class="site-form-checkbox-label" v-if="label">{{ label }}</div>
    </div>

    <div class="site-form-error" v-if="errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "checkbox",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    name: {
      type: String,
    },
    label: {
      type: String,
      default: null
    }
  },
  inject: ['errors', 'formKey'],
  methods: {
    onChange(event) {
      this.$emit('update:modelValue', event.target.checked);
      this.errors[this.name] = null;
    },
  },
  computed: {
    uniqId() {
      return `i-${this.name}`;
    },
    inputName: function () {
      return `${this.formKey}[${this.name}]`;
    },
    errorMessage: function () {
      const errors = this.errors[this.name];
      return errors ? errors.join('') : null;
    }
  },
}
</script>

<style scoped>

</style>